















import {
  defineComponent,
} from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'ElementSeparator',
  props: {
    element: {
      type: Object,
      require: true
    },
    showLine: {
      type: Boolean,
      default() {
        return true
      }
    },
    lineBottom: {
      type: Boolean,
      default() {
        return false;
      }
    },
    description: {
      type: [String, Boolean],
      default() {
        return false
      }
    }
  },
  methods: {
    getBorderStyles() {
      const style = {};

      if (this.element.line_weight) {
        style['border-top-width'] = `${this.element.line_weight}px`
      }

      if (this.element.style) {
        style['border-top-style'] = this.element.style
      }

      if (this.element.color) {
        style['border-color'] = this.element.color
      }

      if (this.element.el_width) {
        style['width'] = `${this.element.el_width}px`
      }

      return style;
    }
  }
});
